module.exports = __webpack_public_path__ + "img/towing@2x.20f8905f.png";